import { render } from "./HeroiconsOutlineArrowNarrowRight.vue?vue&type=template&id=56b58b1b"
const script = {}

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineArrowNarrowRight.vue"]])

export default __exports__